import { DetailedUserDto } from '@studyportals/campaign-management-api-interface';
import { UTCDateTime } from '@studyportals/mb-platform-date-time';

class DatePresenter {
	public retrieveLastLoginDateStringForUser(user: DetailedUserDto | undefined, shortString: boolean): string {
		if (!user?.lastLogin) {
			return 'never';
		}

		const result = (user.lastLogin as unknown as string).slice(0, shortString ? 10 : 19);
		if (shortString) {
			return result;
		}

		return result.replace('T', ' ');
	}

	public transformDateObjectToUTCDateString(value: Date, yearFirst = false): string {
		const date = UTCDateTime.fromDate(value);
		const isoString = date.toShortDateString();
		if (yearFirst) {
			return isoString;
		}

		return `${isoString.substring(8, 10)}/${isoString.substring(5, 7)}/${isoString.substring(0, 4)}`;
	}

	public transformUTCDateStringToDateObject(value: string): Date {
		if (!this.isUTCDateStringValid(value)) {
			throw new Error(`DatePresenter.transformUTCDateStringToDateObject: invalid date string: ${value}`);
		}

		const date = UTCDateTime.fromISOString(value);
		return date.externalizeDate();
	}

	private isUTCDateStringValid(value: string): boolean {
		if (value.length !== 10) {
			return false;
		}

		const numberIndexes = [0, 1, 2, 3, 5, 6, 8, 9];
		for (const index of numberIndexes) {
			if (isNaN(parseInt(value[index]))) {
				return false;
			}
		}

		const dashIndexes = [4, 7];
		for (const index of dashIndexes) {
			if (value[index] !== '-') {
				return false;
			}
		}

		return true;
	}
}

export default new DatePresenter();
